import React, { useEffect, useState, useContext, useRef } from 'react'
import { Link, useLocation, useHistory } from 'react-router-dom'
import UserContext from '../../config/UserContext'
import {
  HttpService,
  API,
  SimpleReactValidator,
  swal,
  Title,
  toast,
  Messages,
  DateFormat,
  Spinner,
  toTitleCase
} from '../../config/react'
import CheckboxTree from 'react-checkbox-tree'
import DataTable from 'react-data-table-component'
// import ProductDetail from './ProductDetail'

const Products = () => {
  const path = useLocation()
  const [ProductList, setProductList] = useState([])
  const user = useContext(UserContext)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [ShowFilters, setShowFilters] = useState(false)
  const [totalRows, settotalRows] = useState(0)
  const [selectedProducts, setselectedProducts] = useState([])
  const [IsSelectAll, setIsSelectAll] = useState(false)
  const [, setSelectedProductCount] = useState(0)
  const [currentPage, setCurrentPage] = useState(
    path.state ? (parseInt(path.state.state.page) === 0 ? 1 : parseInt(path.state.state.page)) : 1
  )
  const history = useHistory()
  const [Categories, setCategories] = useState([])
  const [Attributeset, setAttributeset] = useState([])

  // const [ProductData, setProductData] = useState([])
  // const [Sku, setSku] = useState('')
  // const [IsShowProductModal, setIsShowProductModal] = useState(false)
  const validator = useRef(new SimpleReactValidator())
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const [SelectedCategoryIds, setSelectedCategoryIds] = useState(
    path.state?.state?.categoryIds !== undefined ? JSON.parse(path.state.state.categoryIds) : []
  )
  const [filterText, setFilterText] = useState('')
  const [expanded, setExpanded] = useState([])
  const [clicked, setClicked] = useState(false)
  // const [Vendorlist, setVendorlist] = useState([])

  const DefaultFilters = {
    name: path.state?.state?.name !== undefined ? path.state.state.name : '',
    sku: path.state?.state?.sku !== undefined ? path.state.state.sku : '',
    priceTo: path.state?.state?.priceTo !== undefined ? path.state.state.priceTo : '',
    priceFrom: path.state?.state?.priceFrom !== undefined ? path.state.state.priceFrom : '',
    page: currentPage,
    page_size: 20,
    attribute_set_id:
      path.state?.state?.attribute_set_id !== undefined ? path.state.state.attribute_set_id : 0,
    vendor: path.state?.state?.vendor !== undefined ? path.state.state.vendor : ''
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  console.log(CustomFilters.vendor)

  const columns = [
    {
      name: 'Image',
      selector: function (data, type, row) {
        return (
          <img
            className="my-2"
            width="95px"
            height="95px"
            src={data.base_image}
          ></img>
        )
      }
    },
    {
      name: 'SKU',
      selector: (row) => row.sku,
      wrap: true
    },
    {
      name: 'Name',
      selector: (row) => toTitleCase(row.name),
      wrap: true
    },
    {
      name: 'Attribute Set',
      selector: (row) => row.attribute_set_name
    },
    // {
    //   name: 'Category',
    //   selector: (row) => row.categories,
    //   wrap: true
    // },
    {
      name: 'Created Date',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>,
      wrap: true
    },
    {
      name: 'Action',
      selector: function (data, type, row) {
        // console.log('parent_product_id '+data.parent_product_id+' &SKU '+data.sku);

        return (
          <div className="action-btn">
            {(parseInt(data.parent_product_id) === 0 || data.parent_product_id === null) && (
              <Link
                to={
                  '/products/edit/' +
                  data.id +
                  '?page=' +
                  currentPage +
                  '&sku=' +
                  CustomFilters.sku +
                  '&name=' +
                  CustomFilters.name +
                  '&aid=' +
                  CustomFilters.attribute_set_id +
                  '&priceto=' +
                  CustomFilters.priceTo +
                  '&pricefrom=' +
                  CustomFilters.priceFrom +
                  '&cid=' +
                  JSON.stringify(SelectedCategoryIds) +
                  '&vendor=' +
                  CustomFilters.vendor
                }
                className="text-dark"
                title="Edit"
              >
                <i
                  className="fa fa-pencil-square-o"
                  aria-hidden="true"
                ></i>{' '}
              </Link>
            )}

            <Link
              onClick={(e) => DeleteProducts(e, data.id)}
              to=""
              className="text-dark"
              title="Delete"
            >
              <i
                className="fa fa-trash-o"
                aria-hidden="true"
              ></i>{' '}
            </Link>
          </div>
        )
      }
    }
  ]

  const priceTo = useRef(null)
  const priceFrom = useRef(null)

  useEffect(() => {
    setIsAuth(true)
    document.title = Title.Products
    GetProductsList()
    GetCategories()
    //  GetVendorlist()
    GetProductAttributeSetList()
  }, [CustomFilters, path])

  // const GetVendorlist = () => {
  //   const param = {
  //     id: 65 // single attribute vendor id
  //   }
  //   HttpService.postApi(API.GetProductAttributeDetail, param).then((response) => {
  //     try {
  //       if (response.data.result[0]) {
  //       //  const data = response.data.result[0][0].attribute_options
  //         // setVendorlist(data)
  //       }
  //     } catch (error) {
  //       console.log(error)
  //     }
  //   })
  // }

  const handleClick = () => {
    clicked ? setClicked('') : setClicked('text-left form-control custom-select show')
  }
  const onCheck = (checkedValues) => {
    setSelectedCategoryIds(checkedValues)
  }
  const onExpand = (value) => {
    setExpanded(value)
  }
  const GetProductAttributeSetList = () => {
    const passData = {
      page: 1,
      search: '',
      page_size: 50,
      sort_column: '',
      sort_direction: ''
    }
    // console.log('LN 65 Page '+CustomFilters.page+' &page_size '+CustomFilters.page_size);
    setLoading(true)
    HttpService.postApi(API.GetProductAttributeSetAdminList, passData).then((response) => {
      setLoading(false)
      // setSizeList(response.data.result[0])
      if (response.data.status === true) {
        const data = response.data.result[1].filter((x) => x.is_product_exist)
        setAttributeset(data)
      }
    })
  }
  const GetProductsList = () => {
    const productData = {
      sku: CustomFilters.sku,
      name: CustomFilters.name,
      priceFrom:
        CustomFilters.priceFrom !== null && Number(CustomFilters.priceFrom) > 0
          ? Number(CustomFilters.priceFrom)
          : 0,
      priceTo: CustomFilters.priceTo !== null ? Number(CustomFilters.priceTo) : '-',
      page: CustomFilters.page === 0 ? 1 : CustomFilters.page,
      page_size: CustomFilters.page_size,
      category: SelectedCategoryIds ? SelectedCategoryIds.join(',') : '',
      attribute_set_id: CustomFilters.attribute_set_id,
      vendor: CustomFilters.vendor
    }
    setLoading(true)
    HttpService.postApi(API.GetProductsAdminList, productData).then((response) => {
      try {
        if (response.data.status === true) {
          const data = response.data.result[1]
          setProductList([])
          setProductList(data)
          settotalRows(response.data.result[0][0].total_row)
          setSelectedProductCount(0)
          setForceUpdate(!isForceUpdate)
          setLoading(false)
        }
      } catch (error) {
        console.error(error)
        setLoading(false)
      }
    })
  }

  const GetCategories = (selectedCategory = []) => {
    HttpService.postApi(API.GetCategory, null).then((response) => {
      if (response.data.result) {
        const lastNodeIds = []

        const buildTree = (parentId) => {
          const nodes = response.data.result[0]
            .filter((x) => x.is_diamond_category !== 1)
            .filter((x) => x.parent_id === parentId && x.status)
            .map((item) => {
              const children = buildTree(item.id)

              // If the node has no children, it's a leaf node
              if (children.length === 0) {
                lastNodeIds.push(item.id) // Add leaf node's ID to lastNodeIds
              }

              const allChildrenSelected =
                children.length > 0 && children.every((child) => child.checked) // All children are selected
              const checked = allChildrenSelected || selectedCategory.includes(item.id) // Check if all children or the current category is selected

              return {
                label: item.name,
                value: item.id,
                checked,
                children
              }
            })

          return nodes
        }

        const categories = buildTree(1)
        setCategories(categories)

        //    const updatedSelectedCategoryIds = selectedCategory.filter((id) => lastNodeIds.includes(id))

        //    setSelectedCategoryIds(updatedSelectedCategoryIds)

        // console.log('Last node IDs: ', lastNodeIds)
        // console.log('Updated SelectedCategoryIds: ', updatedSelectedCategoryIds)
      }
    })
  }

  // const ShowProductData = (e, sku) => {
  //   setSku(sku)
  //   e.preventDefault()
  //   const param = {
  //     sku,
  //     country_id: '8',
  //     priceColumn: 'US'
  //   }
  //   setIsAuth(false)
  //   HttpService.postApi(API.GetProductDetailBySku, param).then((response) => {
  //     // var filtered_Sku=response.data.result[0].filter(x=>x.sku===sku);
  //     setProductData(response.data.result)
  //     setIsShowProductModal(true)
  //     setIsAuth(true)
  //     setForceUpdate(!isForceUpdate)
  //   })
  // }
  // const onCloseModal = () => {
  //   GetProductsList()
  //   setIsShowProductModal(false)
  //   setForceUpdate(!isForceUpdate)
  // }
  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
    // GetProductsList();
  }

  const DeleteProducts = async (e, id, sku) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        PostDeleteProduct(id)
      }
    })
  }

  const DeleteSelectedProducts = async (e) => {
    e.preventDefault()

    if ((selectedProducts === undefined || selectedProducts.length === 0) && !IsSelectAll)
      toast.warning(Messages.SelectAtlestOneItem)
    else {
      // console.log("Ln 125");
      // console.log(selectedProducts);

      swal(Messages.SwalDeleteProp).then(function (isConfirm) {
        if (isConfirm) {
          const ids = []
          // const skus = []
          // var setIds = ''
          if (selectedProducts.length > 0) {
            selectedProducts.forEach((arr) => ids.push(arr.id))
            PostDeleteProduct(ids.join(','))
          } else {
            PostDeleteProduct('')
          }
        }
      })
    }
  }

  const PostDeleteProduct = (id) => {
    const param = {
      id,
      IsDeleted: true,
      Userid: user.id,
      is_delete_all: IsSelectAll === true ? 1 : 0
    }

    // console.log("Ln 152 PostDeleteProduct");
    // console.log(param);
    // return;

    HttpService.postApi(API.DeleteProducts, param).then((response) => {
      toast.success(Messages.RecordDeleted)
      setIsSelectAll(false)
      GetProductsList()
      setselectedProducts([])
      setForceUpdate(!isForceUpdate)
    })
  }

  const handleInputChanges = (prop) => (e) => {
    const priceLength = Messages.pricelength
    const lastPrice = Messages.pricehighest

    // console.log('priceLength '+priceLength+ ' & '+lastPrice);
    if (e.target.value.length > priceLength && (prop === 'priceTo' || prop === 'priceFrom')) {
      if (prop === 'priceFrom' && e.target.value > lastPrice)
        priceFrom.current.value = e.target.value.slice(0, priceLength)
      else if (prop === 'priceTo' && e.target.value > lastPrice)
        priceTo.current.value = e.target.value.slice(0, priceLength)
    } else {
      CustomFilters[prop] = e.target.value
    }
    setForceUpdate(!isForceUpdate)
  }

  const ClearFilter = (e) => {
    // e.preventDefault()
    history.push(path.pathname, null)
    setSelectedCategoryIds([])
    setCustomFilters({
      name: '',
      sku: '',
      priceTo: '',
      priceFrom: '',
      page: currentPage,
      page_size: 20,
      attribute_set_id: 0,
      vendor: ''
    })
    setForceUpdate(!isForceUpdate)
    priceTo.current.value = ''
    priceFrom.current.value = ''
    setFilterText('')
    // GetProductsList()
  }

  const openFilterBox = (e) => {
    e.preventDefault()
    if (ShowFilters) {
      setShowFilters(false)
    } else {
      setShowFilters(true)
    }
  }

  const handleChange = (state) => {
    setselectedProducts(state.selectedRows)
    setSelectedProductCount(state.selectedRows.length)
  }

  const DeleteAll = (e) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        setIsSelectAll(true)
      }
    })
  }

  const onFilterChange = (e) => {
    setFilterText(e.target.value.toLowerCase())
  }
  const filterNodes = (nodes, searchText) => {
    const loweredSearchText = searchText.toLowerCase()
    return nodes
      .map((node) => {
        const isNodeMatching = node.label.toLowerCase().includes(loweredSearchText)
        let filteredChildren = null
        if (node.children) {
          filteredChildren = filterNodes(node.children, loweredSearchText)
        }
        if (isNodeMatching || (filteredChildren !== null && filteredChildren.length > 0)) {
          return {
            ...node,
            children: filteredChildren
          }
        }
        return null
      })
      .filter((node) => node !== null)
  }
  const filteredCategories = filterNodes(Categories, filterText)

  useEffect(() => {
    if (IsSelectAll) PostDeleteProduct('')
  }, [IsSelectAll])

  // const SelectAll = (e) => {
  //     e.preventDefault();
  //     if (!IsSelectAll) {
  //         setSelectedProductCount(totalRows);
  //     }
  //     else {
  //         setSelectedProductCount(0);
  //     }

  //     setIsSelectAll(!IsSelectAll);
  // }

  const SelectAllCheckbox = React.forwardRef(({ onClick, ...rest }, ref) => (
    <div className="form-check">
      <input
        htmlFor="select-all"
        type="checkbox"
        className="form-check-input"
        ref={ref}
        onClick={onClick}
        checked
        {...rest}
      />
    </div>
  ))
  const preventMinus = (e) => {
    if (e.code === 'Minus' || e.code === 'NumpadSubtract') {
      e.preventDefault()
    }
  }

  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <h3 className="page-title mb-3"> {Title.Products} </h3>
      <div className="page-header">
        <div className="btn-group">
          <Link
            onClick={DeleteSelectedProducts}
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            {Title.DeleteSelected}{' '}
          </Link>
          <Link
            onClick={DeleteAll}
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            {Title.DeleteAll}{' '}
          </Link>
          {/* {
                        SelectedProductCount > 0 &&
                        <>
                            <span className='m-2'>{SelectedProductCount} product(s) selected</span>
                            {
                                (CustomFilters.page_size <= SelectedProductCount) &&
                                <button className='btn btn-primary btn-fw rounded mr-2' onClick={SelectAll}>{!IsSelectAll ? 'Select all ' + totalRows : 'Clear Selection'}</button>
                            }
                        </>
                    } */}
        </div>
        <div className="btn-group ml-auto"></div>

        <div className="btn-group">
          <Link
            to="/products/updateprice"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            {Title.UpdatePrice}{' '}
          </Link>
          {/* <Link
            to="/products/importexcel"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            {Title.ImportExcel}{' '}
          </Link> */}
          <Link
            to={
              '/products/add' +
              '?page=' +
              currentPage +
              '&sku=' +
              CustomFilters.sku +
              '&name=' +
              CustomFilters.name +
              '&aid=' +
              CustomFilters.attribute_set_id +
              '&priceto=' +
              CustomFilters.priceTo +
              '&pricefrom=' +
              CustomFilters.priceFrom +
              '&cid=' +
              JSON.stringify(SelectedCategoryIds)
            }
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            {Title.AddProducts}{' '}
          </Link>
          <Link
            to="#"
            onClick={(e) => openFilterBox(e)}
            className="btn btn-primary btn-fw rounded filter-btn mr-2"
          >
            {' '}
            Filters{' '}
          </Link>
        </div>
      </div>

      <div
        className={ShowFilters ? 'filter-bar d-block' : 'filter-bar'}
        id="filter-bar"
      >
        <div className="grid-margin w-100 stretch-card">
          <div className="card">
            <div className="card-body">
              <form>
                <div className="row">
                  <div className="col-md-6 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">
                        <strong>SKU</strong>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={handleInputChanges('sku')}
                        value={CustomFilters.sku}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">
                        <strong>Name</strong>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={handleInputChanges('name')}
                        value={CustomFilters.name}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="form-group">
                      <label>Category</label>

                      <div className="custom-dropdown text-left">
                        <button
                          type="button"
                          className={clicked || 'text-left form-control custom-select'}
                          onClick={handleClick}
                        >
                          Select Category
                        </button>
                        <div className="dropdown-menu p-1 mt-3">
                          <input
                            className="form-control p-1 mb-2"
                            placeholder="Search..."
                            type="text"
                            value={filterText}
                            onChange={onFilterChange}
                          />
                          <CheckboxTree
                            checked={SelectedCategoryIds}
                            expandOnClick
                            expanded={expanded}
                            nodes={filteredCategories}
                            onCheck={onCheck}
                            onExpand={onExpand}
                            icons={{
                              parentClose: null, // Hides the folder icon for closed parent nodes
                              parentOpen: null, // Hides the folder icon for opened parent nodes
                              leaf: null
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">
                        <strong>Price</strong>
                      </label>
                      <div className="form-group mb-2 row align-items-center">
                        <div className="col-md-5 pr-md-2">
                          <input
                            type="number"
                            min={1}
                            ref={priceFrom}
                            className="form-control"
                            placeholder="From"
                            value={CustomFilters.priceFrom}
                            onChange={handleInputChanges('priceFrom')}
                            onKeyPress={preventMinus}
                          />
                        </div>
                        <div className="col-md-6 pl-md-3">
                          <input
                            type="number"
                            min={0}
                            className="form-control"
                            placeholder="To"
                            onChange={handleInputChanges('priceTo')}
                            ref={priceTo}
                            value={CustomFilters.priceTo}
                            onKeyPress={preventMinus}
                            name="priceTo"
                          />
                          {validator.current.message(
                            'priceTo',
                            CustomFilters.priceTo,
                            'required|numeric|min:0,max:999,num',
                            { className: 'error' }
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Attribute Set</label>
                      <select
                        className="form-control custom-select"
                        name="attribute_set_id"
                        value={CustomFilters.attribute_set_id}
                        onChange={handleInputChanges('attribute_set_id')}
                      >
                        <option value="">--Select--</option>
                        {Attributeset.map((attributeSet, index) => (
                          <option
                            key={index}
                            value={attributeSet.id}
                          >
                            {attributeSet.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {/* <div className="col-md-3">
                    <div className="form-group">
                      <label>Vendor</label>
                      <select
                        className="form-control custom-select"
                        name="vendor"
                        value={CustomFilters.vendor}
                        onChange={handleInputChanges('vendor')}
                      >
                        <option value="">--Select--</option>
                        {Vendorlist.map((Vendor, index) => (
                          <option
                            key={index}
                            value={Vendor.value}
                          >
                            {Vendor.value}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div> */}
                  {/* <div className="col-md-3 p-4"></div>
                  <div className="col-md-3 p-4"></div> */}
                  <div className="col-md-3 p-4">
                    <div className="btn-group">
                      <Link
                        className="btn btn-dark btn-fw-130 rounded mr-2"
                        onClick={(e) => GetProductsList(e)}
                      >
                        {' '}
                        Apply{' '}
                      </Link>
                      <div className="btn-group ml-auto">
                        <Link
                          className="btn btn-primary btn-fw-130 rounded mr-2"
                          onClick={(e) => ClearFilter(e)}
                        >
                          {' '}
                          Reset{' '}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={ProductList}
                  progressPending={loading}
                  progressComponent={<Spinner />}
                  selectableRows
                  pagination
                  paginationServer
                  paginationPerPage={20}
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  onSelectedRowsChange={handleChange}
                  selectableRowsComponent={SelectAllCheckbox}
                  paginationDefaultPage={currentPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {IsShowProductModal === true && (
        <ProductDetail
          props={{ IsShowProductModal, product: ProductData, sku: Sku }}
          onCloseModal={onCloseModal}
        />
      )} */}
    </div>
  )
}

export default Products
